import { Layout } from 'layouts';
import { Unsubscribe } from 'features/unsubscribe';
import { useUnsubscribeParams } from './hooks';

const PageUnsubscribe = () => {
  const { params } = useUnsubscribeParams();

  return (
    // TODO: Fix css properly
    <Layout className="unsubscribe-page">
      <Unsubscribe token={params.token} />
    </Layout>
  );
};

export default PageUnsubscribe;
